<template>
  <div>
    <div v-if="!loading">
      <v-btn
        v-if="toCategory"
        :to="toCategory"
        :color="article.category.color"
        class="rounded-pill px-6 font-weight-bold roboto-condensed white--text"
        small
        depressed
      >
        {{ article.category.title }}
      </v-btn>

      <div
        class="title-article grey--text text--darken-4 mt-2"
        v-if="article.title"
        v-html="article.title"
      ></div>

      <div>
        {{ article.intro }}
      </div>

      <v-row align="center">
        <v-col cols="12" sm="6" class="mt-4">
          <div
            class="source-article grey--text text--darken-2"
            v-if="article.source"
          >
            <b>Fonte:</b> {{ article.source }}
          </div>

          <div
            class="source-article grey--text text--darken-2"
            v-if="article.local"
          >
            <b>Local:</b> {{ article.local }}
          </div>

          <div class="date-article grey--text text--darken-1 mt-2" v-if="date">
            <v-icon class="mr-1"> far fa-calendar </v-icon>
            {{ date }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="mt-4">
          <div class="float-sm-right">
            <share-buttons />
          </div>
        </v-col>
      </v-row>

      <div class="mt-6">
        <v-responsive :aspect-ratio="16 / 9" v-if="embedVideo">
          <iframe
            width="100%"
            height="100%"
            fill-height
            :src="embedVideo"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-responsive>
        <template v-else-if="article.img && article.img.featured">
          <img
            :src="this.files + article.img.featured.path + '?resize=1&w=750'"
            :alt="article.title"
            width="100%"
          />
          <div class="grey--text text--darken-4 mt-2 text-small">
            <i>{{ article.img.featured.title }}</i>
          </div>
        </template>
      </div>

      <div
        class="text-article grey--text text--darken-4 mt-6"
        v-if="article.text_1"
        v-html="article.text_1"
      ></div>
      <div
        class="text-article grey--text text--darken-4 mt-6"
        v-if="article.text_2"
        v-html="article.text_2"
      ></div>

      <div
        class="source-article grey--text text--darken-2"
        v-if="article.author"
      >
        Autor: {{ article.author }}
      </div>
    </div>
    <Loading v-else class="my-16" />
  </div>
</template>

<script>
import ShareButtons from "@/components/widgets/ShareButtons.vue";
import Loading from "@/components/widgets/Loading.vue";
import { formatToURL, getYoutubeCode } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    article: [],
  }),
  props: {
    type: {
      type: String,
      default: "articles",
    },
    params: {
      type: Object,
    },
  },
  computed: {
    articleId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    toCategory() {
      if (!this.article.category) return "";
      return `/noticias/${formatToURL(this.article.category.title)}`;
    },
    embedVideo() {
      if (!this.$rest(this.type).item.link) return "";
      return `https://www.youtube.com/embed/${getYoutubeCode(
        this.article.link
      )}`;
    },
    date() {
      if (!this.article.date) return "";
      return this.formatDate(this.article.date);
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date.replace(" ", "T"))
      );
    },
    get() {
      this.loading = true;
      this.data = {};

      var params = {};
      if (this.params) params = this.params;

      this.$rest(this.type)
        .get({ id: this.articleId, params })
        .then((data) => {
          this.article = data;

          this.loading = false;

          this.$rest(this.type).put({
            id: this.articleId,
            prop: "view",
            data: { value: 1 },
          });
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    articleId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    ShareButtons,
    Loading,
  },
};
</script>

<style scoped>
.category-article a {
  background-color: #2d4379;
  border-radius: 25rem;
  color: #ffffff;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  padding: 3px 23px;
  transition: all 0.1s linear;
}

.category-article a:hover {
  opacity: 0.9;
}

.title-article {
  font-size: 32px !important;
  font-weight: 700;
  line-height: 38px;
}

@media (max-width: 1199px) {
  .title-article {
    font-size: 26px !important;
  }
}

@media (max-width: 700px) {
  .title-article {
    font-size: 22px !important;
  }
}

.source-article b {
  font-weight: 600;
}

.date-article .v-icon {
  font-size: 16px;
  vertical-align: baseline;
}

.share-article {
  background-color: #3b5998;
  color: #ffffff;
  font-size: 14px;
}

.share-article .v-icon {
  font-size: 16px;
}

.share-article-item {
  letter-spacing: 0.2px;
}

.facebook-icon {
  color: #4267b2 !important;
}

.whatsapp-icon {
  color: #25d366 !important;
}

.twitter-icon {
  color: #1da1f2 !important;
}
</style>

<style>
.text-article img {
  margin: 20px 0 !important;
  width: 100%;
}

.text-article img ~ .text-small {
  top: -15px;
  position: relative;
}

.text-article a * {
  color: var(--v-primary-base) !important;
}

.text-small {
  font-size: 80%;
}
</style>
